import React,{ useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, ContentContainer, Row, Button, Heading, SectionHeader,
    IconNotificationError } from '@snsw-gel/react';
import styles from './ApplicationError.module.scss';
import { dataLayer } from '../../../services/gtm-dataLayer';

const ApplicationErrorPage = () => {

    const history = useHistory();
    const [genericError,setGenericError]=useState(false);
    const errorDetails = value => {
        console.log(value);
        switch (value) {
        case 'User already has a card':
            history.push('/cardError');
            break;
        case 'Invalid date of birth':
            history.push('/ageError');
            break;
        case 'Invalid address':
            history.push('/addressError');
            break;
        case 'Residency status not proven':
            history.push('/residencyError');
            break;
        default:
            setGenericError(true);
            break;

        }
    };

    useEffect(()=>{
        const errorData = JSON.parse(sessionStorage.getItem('ErrorResponseText'));

        if(errorData && errorData.errors)
        {
            if(errorData.type === 'validation')
            {
                errorDetails(errorData.errors[0]);
            }
        }
        setGenericError(true);
    },[]);

    useEffect(() => {
        const currentUrl=window.location.href;
        const pageName=window.location.href.split('/').pop();
        console.log(currentUrl,pageName);
        dataLayer(currentUrl,pageName);
    }, []);

    return (

        <>
            { genericError &&
          <>
              <SectionHeader className={ styles['heading-section'] }
                  label='Apply for a NSW Seniors Card or NSW Senior Savers Card '>
                  <Heading className={ styles['heading-alignment']} level={ 1 } >
                      <IconNotificationError/>
                   We were unable to process your application
                  </Heading>
              </SectionHeader>

              <ContentContainer className={ styles['content-container'] }>
                  <Row>
                      <Col span={ 9 }>
                          <p>Unfortunately there was an issue while processing your application. Try again later, or alternatively call us
                                on <a aria-label='Call us on 1 3 7 7 8 8' href='tel:137788'>13 77 88</a>.</p>
                      </Col>
                  </Row>

                  <Button
                      className={ styles['start-button'] }
                      variant='primary'
                      aria-label='Start application again'
                      onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card' }
                  >
                    Start application again
                  </Button>
                  <Button
                      className={ styles['home-button'] }
                      variant='secondary'
                      aria-label='Go to Service New South Wales homepage'
                      onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/' }>Go to Service NSW homepage
                  </Button>
              </ContentContainer>
          </>}
        </>
    );
};

export default ApplicationErrorPage;

